// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Account } from '../../../cache/Account';
import { TvAccountHelper } from '../../Helpers/TvAccountHelper';
import { FAILED_TO_FORMAT } from './BaseCustomTableFormatterName';
export class BaseCustomTableFormatter {
    constructor(name, accountFeatureType) {
        this.name = name;
        this.accountFeatureType = accountFeatureType;
        this.formatText = this.formatText.bind(this);
        this.formatElement = this.formatElement.bind(this);
    }
    formatText(inputs) {
        const inputValue = inputs.values[0];
        if (inputs.values.length !== 1 || isNullOrUndefined(inputValue)) {
            return FAILED_TO_FORMAT;
        }
        if (isValidNumber(inputValue)) {
            const account = TvAccountHelper.getCurrentAccount();
            return Account.GetAccountFeatureString(inputValue, this.accountFeatureType, account, account.assetBalanceDefault);
        }
        return inputValue.toString();
    }
    formatElement(inputs) {
        const formattedText = this.formatText(inputs);
        if (formattedText === FAILED_TO_FORMAT) {
            return undefined;
        }
        let result;
        const numericValue = parseFloat(formattedText);
        if (isValidNumber(numericValue)) {
            const colorStyle = numericValue > 0 ? 'green' : numericValue < 0 ? 'red' : '';
            const span = document.createElement('span');
            span.style.color = colorStyle;
            span.textContent = formattedText;
            result = span;
        }
        else {
            result = formattedText;
        }
        return result;
    }
}
